// import path from "path";
import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import LayOut from "src/layouts/workWithSurveys/WorkWithStartPageLayout";
const Disclaimer = lazy(()=> import("src/layouts/workWithSurveys/workWithComponents/disclaimer"));

export const workWithSurveyRoutes = [
    {
        path: "",
        element: (
            <LayOut>
                <Suspense>
                    <Outlet/>
                </Suspense>
            </LayOut>
        ),
        children :[
           { path:"workWithSurvey",
            index:true,
            element: <Disclaimer/>}
        ]
    }
]